import type { SkillGroup } from './types';

export const skillGroups: SkillGroup[] = [
  {
    id: 'frontend',
    i18n: { 'pt-BR': { title: 'Frontend' }, en: { title: 'Frontend' } },
    skills: [
      { id: 'vue', i18n: { 'pt-BR': { name: 'Vue' }, en: { name: 'Vue' } } },
      { id: 'react', i18n: { 'pt-BR': { name: 'React' }, en: { name: 'React' } } },
      { id: 'next', i18n: { 'pt-BR': { name: 'Next.js' }, en: { name: 'Next.js' } } },
      { id: 'typescript', i18n: { 'pt-BR': { name: 'TypeScript' }, en: { name: 'TypeScript' } } },
      { id: 'html-css', i18n: { 'pt-BR': { name: 'HTML/CSS' }, en: { name: 'HTML/CSS' } } },
      { id: 'a11y', i18n: { 'pt-BR': { name: 'Acessibilidade' }, en: { name: 'Accessibility' } } },
    ],
  },
  {
    id: 'quality',
    i18n: { 'pt-BR': { title: 'Qualidade' }, en: { title: 'Quality' } },
    skills: [
      { id: 'vitest', i18n: { 'pt-BR': { name: 'Vitest' }, en: { name: 'Vitest' } } },
      { id: 'jest', i18n: { 'pt-BR': { name: 'Jest' }, en: { name: 'Jest' } } },
      { id: 'cypress', i18n: { 'pt-BR': { name: 'Cypress' }, en: { name: 'Cypress' } } },
      { id: 'playwright', i18n: { 'pt-BR': { name: 'Playwright' }, en: { name: 'Playwright' } } },
      { id: 'eslint', i18n: { 'pt-BR': { name: 'ESLint' }, en: { name: 'ESLint' } } },
      { id: 'sonarqube', i18n: { 'pt-BR': { name: 'SonarQube' }, en: { name: 'SonarQube' } } },
      { id: 'quality-gate', i18n: { 'pt-BR': { name: 'Quality Gate' }, en: { name: 'Quality Gate' } } },
    ],
  },
  {
    id: 'architecture',
    i18n: {
      'pt-BR': { title: 'Arquitetura e Entrega' },
      en: { title: 'Architecture & Delivery' },
    },
    skills: [
      { id: 'cicd', i18n: { 'pt-BR': { name: 'CI/CD' }, en: { name: 'CI/CD' } } },
      { id: 'github-actions', i18n: { 'pt-BR': { name: 'GitHub Actions' }, en: { name: 'GitHub Actions' } } },
      { id: 'docker', i18n: { 'pt-BR': { name: 'Docker' }, en: { name: 'Docker' } } },
      { id: 'design-systems', i18n: { 'pt-BR': { name: 'Design Systems' }, en: { name: 'Design Systems' } } },
      { id: 'git-flow', i18n: { 'pt-BR': { name: 'Git Flow' }, en: { name: 'Git Flow' } } },
    ],
  },
  {
    id: 'ai',
    i18n: {
      'pt-BR': { title: 'IA e Produtividade' },
      en: { title: 'AI & Productivity' },
    },
    skills: [
      { id: 'harness', i18n: { 'pt-BR': { name: 'Harness Engineering' }, en: { name: 'Harness Engineering' } } },
      { id: 'sdd', i18n: { 'pt-BR': { name: 'SDD' }, en: { name: 'SDD' } } },
      { id: 'cursor', i18n: { 'pt-BR': { name: 'Cursor' }, en: { name: 'Cursor' } } },
      { id: 'ai-assisted', i18n: { 'pt-BR': { name: 'IA assistida' }, en: { name: 'AI-assisted dev' } } },
    ],
  },
  {
    id: 'complementary',
    i18n: { 'pt-BR': { title: 'Complementar' }, en: { title: 'Complementary' } },
    skills: [
      { id: 'node', i18n: { 'pt-BR': { name: 'Node.js' }, en: { name: 'Node.js' } } },
      { id: 'laravel', i18n: { 'pt-BR': { name: 'PHP/Laravel' }, en: { name: 'PHP/Laravel' } } },
      { id: 'ionic', i18n: { 'pt-BR': { name: 'Ionic' }, en: { name: 'Ionic' } } },
      { id: 'tauri', i18n: { 'pt-BR': { name: 'Tauri' }, en: { name: 'Tauri' } } },
    ],
  },
];
